module.exports = __webpack_public_path__ + "img/Vattenfall_120X35.0788b341.png";